import { createNotificationTarget } from './createdRecord';

const normalizeSection = (value) => {
  const section = String(value ?? '').trim().toLocaleLowerCase('es-CO');
  if (section.startsWith('estadia') || section.startsWith('estadía')) return 'Estadias';
  if (section.startsWith('mensualidad')) return 'Mensualidades';
  return null;
};

export const resolveNotificationTarget = (notification) => {
  const explicitSection = normalizeSection(
    notification?.targetSection ?? notification?.target_section ?? notification?.seccion
  );
  const targetSection = explicitSection
    ?? (notification?.estadia_id ? 'Estadias' : 'Mensualidades');
  const recordId = notification?.targetId
    ?? notification?.target_id
    ?? (targetSection === 'Estadias' ? notification?.estadia_id : notification?.mensualidad_id)
    ?? notification?.id;

  return createNotificationTarget(targetSection, recordId);
};

export const getNotificationKey = (notification) => {
  const target = resolveNotificationTarget(notification);
  return target ? `${target.targetSection}:${target.createdId}` : null;
};

export const removeNotification = (notifications, discarded) => {
  const discardedKey = getNotificationKey(discarded);
  if (!discardedKey || !Array.isArray(notifications)) return notifications;
  return notifications.filter((item) => getNotificationKey(item) !== discardedKey);
};
